/**
 * Trovva — Stage-gating rules for lead status transitions.
 * Kept in a lib file (no React) so Fast Refresh stays happy.
 */

// Rules: what fields are required to reach each status.
export const STAGE_REQUIREMENTS = {
  // Residential
  qualified:        ['budget', 'timeline'],
  offer_submitted:  ['property_address', 'offer_amount', 'offer_date'],
  offer_accepted:   ['property_address', 'accepted_price', 'closing_date_target'],
  // Commercial
  loi_submitted:    ['property_address', 'loi_amount'],
  loi_accepted:     ['property_address', 'loi_amount', 'commercial_sub_type'],
};

// Contingency options for offer forms
export const CONTINGENCY_OPTIONS = [
  { key: 'inspection',      label: 'Home Inspection' },
  { key: 'financing',       label: 'Financing / Mortgage' },
  { key: 'attorney_review', label: 'Attorney Review (NJ 3-day)' },
  { key: 'appraisal',       label: 'Appraisal' },
  { key: 'sale_of_home',    label: 'Sale of Existing Home' },
];

/**
 * Returns the list of required fields missing for the target status.
 * If no requirements or all filled, returns [].
 */
export function missingForStage(lead, targetStatus) {
  const required = STAGE_REQUIREMENTS[targetStatus];
  if (!required) return [];
  return required.filter(f => {
    const v = lead?.[f];
    if (f === 'preapproved') return v === null || v === undefined;
    return !v || String(v).trim() === '';
  });
}
